import React from 'react';
import Modal from '../modal';

type ActionType = 'remove' | 'close';

interface ModalPopUpProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  messageDescription?: string;
  isMobileSize?: boolean;
  overlayZIndex?: number;
  ffidValue?: string;
  className?: string;

  showCancelButton?: boolean;
  cancelText?: string;
  onCancel?: () => void;

  actionType?: ActionType;
  actionText?: string;
  onAction?: () => void;
  isActionDisabled?: boolean;
}

const ModalPopUp: React.FC<ModalPopUpProps> = ({
  isOpen,
  onClose,
  title,
  messageDescription,
  isMobileSize = false,
  overlayZIndex,
  ffidValue,
  className = 'border z-50',

  showCancelButton = false,
  cancelText = 'Cancel',
  onCancel,

  actionType = 'close',
  actionText,
  onAction,
  isActionDisabled = false,
}) => {
  const handleCancel = onCancel ?? onClose;
  const handleAction = onAction ?? onClose;

  const resolvedActionText = actionText ?? (actionType === 'remove' ? 'Remove' : 'Close');

  const baseBtn =
    'w-[154px] h-[50px] rounded-full px-6 py-3 text-[14px] font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 shadow-sm';

  const cancelClasses = `${baseBtn} border border-[#018463] bg-white text-[#018463] hover:border-[#349D82] hover:text-[#349D82] focus-visible:ring-[#349D82]`;

  const actionClasses = `${baseBtn} bg-[#018463] text-white hover:bg-[#349D82] focus-visible:ring-[#349D82] disabled:cursor-not-allowed disabled:opacity-50`;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      className={className}
      data-ffid={`mdl-${ffidValue}-info`}
      closeButton={false}
      overlayZIndex={overlayZIndex}
      style={{
        content: { backgroundColor: 'white', maxWidth: isMobileSize ? '20rem' : '25rem', padding: 32 },
        overlay: { background: '#333333B2' },
      }}
    >
      <div>
        {title && (
          <h2 className="text-xl font-semibold text-gray-800" data-ffid={`lbl-${ffidValue}-title`}>
            {title}
          </h2>
        )}

        {messageDescription && (
          <p
            data-ffid={`lbl-${ffidValue}-modal-desc`}
            className="mb-60 mt-24 text-18 font-normal text-[#333333] md:mb-36"
          >
            {messageDescription}
          </p>
        )}

        <div className="flex items-center justify-end gap-20">
          {showCancelButton && (
            <button onClick={handleCancel} data-ffid={`btn-${ffidValue}-cancel`} className={cancelClasses}>
              {cancelText}
            </button>
          )}

          <button
            onClick={handleAction}
            disabled={isActionDisabled}
            data-ffid={`btn-${ffidValue}-delete`}
            className={actionClasses}
          >
            {resolvedActionText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalPopUp;
